import { Card } from 'react-bootstrap';
import { FaFileInvoice } from 'react-icons/fa';

const PaymentSummaryCard = ({ 
  formData, 
  originalValues, 
  foodBillBreakdown, 
  formatCurrency 
}) => {
  // Calculate subtotal for display
  const calculateSubtotal = () => {
    return (parseFloat(formData.billDetails.foodBill) || 0) +
           (parseFloat(formData.billDetails.djMusic) || 0) +
           (parseFloat(formData.billDetails.serviceCharges) || 0) +
           (parseFloat(formData.billDetails.hallRent) || 0) +
           (parseFloat(formData.billDetails.bwdStage) || 0) +
           (parseFloat(formData.billDetails.acCharges) || 0) +
           (parseFloat(formData.billDetails.heaterCharges) || 0) +
           (parseFloat(formData.billDetails.ladiesWaiter) || 0) +
           (parseFloat(formData.billDetails.otherCharges) || 0);
  };

  const subtotal = calculateSubtotal();
  const govtTax = parseFloat(formData.billDetails.govtTax) || 0;
  const discount = parseFloat(formData.billDetails.discount) || 0;
  const totalAmount = parseFloat(formData.billDetails.totalAmount) || 0;
  const advancePaid = parseFloat(formData.billDetails.advancePaid) || 0;
  const remainingAmount = parseFloat(formData.billDetails.remainingAmount) || 0;

  return (
    <Card className="border-0 shadow-sm">
      <Card.Header className="bg-white border-0 py-3">
        <h5 className="mb-0 fw-bold">
          <FaFileInvoice className="me-2" />
          Payment Summary
        </h5>
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Subtotal:</span>
          <span className="fw-bold">{formatCurrency(subtotal)}</span>
        </div>
        
        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Government Tax:</span>
          <span className="fw-bold text-warning">+{formatCurrency(govtTax)}</span>
        </div>
        
        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Discount:</span>
          <span className="fw-bold text-danger">-{formatCurrency(discount)}</span>
        </div>
        
        <hr />
        
        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Total Amount:</span>
          <span className="fw-bold text-primary">{formatCurrency(totalAmount)}</span>
        </div>
        
        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Advance Paid:</span>
          <span className="fw-bold text-success">
            -{formatCurrency(advancePaid)}
          </span>
        </div>
        
        <hr />
        
        <div className="d-flex justify-content-between mb-2">
          <span className="fw-bold">Remaining Balance:</span>
          <span className="fw-bold" style={{ 
            color: remainingAmount > 0 ? '#dc3545' : '#198754' 
          }}>
            {formatCurrency(remainingAmount)}
          </span>
        </div>
        
        <div className="mt-3 small text-muted bg-light p-2 rounded">
          <strong>Calculation Details:</strong><br />
          • Food Bill: ({formatCurrency(foodBillBreakdown.perHead)} × {foodBillBreakdown.persons}) + {formatCurrency(foodBillBreakdown.menuTotal)} = {formatCurrency(foodBillBreakdown.totalFoodBill)}<br />
          • Other Charges: {formatCurrency(subtotal - foodBillBreakdown.totalFoodBill)}<br />
          • Subtotal: {formatCurrency(subtotal)}<br />
          • Government Tax (Fixed): +{formatCurrency(govtTax)}<br />
          • Discount: -{formatCurrency(discount)}<br />
          • Total Amount: {formatCurrency(totalAmount)}<br />
          • Advance Paid: -{formatCurrency(advancePaid)}<br />
          • Remaining: {formatCurrency(remainingAmount)}
        </div>
      </Card.Body>
    </Card>
  );
};

export default PaymentSummaryCard;